import { create } from "zustand";

interface ModelCompileStore {
  tick: number;
  ping: () => void;
}

// Bumped every time a streamed-in model finishes compiling its shaders.
// Used to debounce the AccumulativeShadows re-bake to just after the last
// model appears, instead of guessing with wall-clock timers.
export const useModelCompileTick = create<ModelCompileStore>((set) => ({
  tick: 0,
  ping: () => set((s) => ({ tick: s.tick + 1 })),
}));
